/**
 * Feature constants - should match the backend feature schemas
 */

export type WebsiteOption = {
  value: "com_en" | "com_zh" | "fr" | "de";
  domain: string;
  label: string;
  allowedLanguages: string[] | null; // null = any
};

/**
 * The four Legal 500 website targets, in canonical order (English, Mandarin, French, German).
 * Mirrors profiles_website Postgres enum and WEBSITE_ALLOWED_LANGUAGES in profiles-api.
 */
export const WEBSITE_OPTIONS: WebsiteOption[] = [
  {
    value: "com_en",
    domain: "legal500.com",
    label: "English (Legal500.com)",
    allowedLanguages: null,
  },
  {
    value: "com_zh",
    domain: "legal500.com",
    label: "Mandarin (Legal500.com)",
    allowedLanguages: null,
  },
  { value: "fr", domain: "legal500.fr", label: "French (Legal500.fr)", allowedLanguages: ["fr"] },
  { value: "de", domain: "legal500.de", label: "German (Legal500.de)", allowedLanguages: ["de"] },
];

/**
 * Subscription site domains (one entry per distinct domain). NOTE: this is the
 * subscription/onboarding site list and is intentionally NOT derived from
 * WEBSITE_OPTIONS — that splits legal500.com into com_en/com_zh editions, which
 * would duplicate the "legal500.com" domain here and break the site radio picker.
 */
export const SITES = ["legal500.com", "legal500.de", "legal500.fr"];
export const LANGUAGES = ["en", "fr", "de", "it", "ja", "zh", "pl", "pt", "es"];

export const LANGUAGE_LABELS: Record<string, string> = {
  en: "English (en)",
  fr: "French (fr)",
  de: "German (de)",
  it: "Italian (it)",
  ja: "Japanese (ja)",
  zh: "Mandarin (zh)",
  pl: "Polish (pl)",
  pt: "Portuguese (pt)",
  es: "Spanish (es)",
};

export type Website = WebsiteOption["value"];
export type Language = (typeof LANGUAGES)[number];

/** @deprecated Use WEBSITE_OPTIONS instead */
export type Site = string;
